import { render, staticRenderFns } from "./CustomerUserEditor.vue?vue&type=template&id=1fe5b88a"
import script from "./CustomerUserEditor.vue?vue&type=script&lang=js"
export * from "./CustomerUserEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports